<template>
    <div class="mywealth-container">
        <!-- HEADER -->
        <div class="header">
            <div class="back-container">
                <img class="back" :src="Back" alt="Back">
                <span class="title">سرمایه من</span>
            </div>

            <p>موجودی</p>
            <h2>{{ price | comma }} تومان</h2>
        </div>

        <!-- BODY -->
        <div class="other-container">
            <img class="banner" :src="URL + '/' + cover" alt="Card">

            <div class="separator-line"></div>

            <div class="btn-container">
                <button class="btn btn-light btn-right" @click="CheckActivate">افزودن به موجودی</button>
                <button class="btn btn-light btn-left" @click="back">بازگشت</button>
            </div>
        </div>
    </div>
</template>

<script>
import Back from '@/assets/images/mywealth/back.png';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'Activate',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Back: Back,
            URL: APP_API_URL(),

            route: this.$route.name,
            prevRoute: {},

            id: this.$route.params.id,
            price: undefined,
            cover: undefined
        }
    },
    mounted() {
        this.GetCurrent()
    },
    watch: {
        '$route'() {
            this.route = this.$route.name;
        }
    },
    methods: {
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        },
        GetCurrent() {
            getRequest('/cards/find-one', { id: this.id })
                .then(rsp => {
                    // response
                    let data = rsp['data'];

                    this.price = data.Price;
                    this.cover = data.Cover;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        // show confirm dialog for deleting 
        CheckActivate() {
            this.$modal.show('dialog', {
                title: 'هشدار!',
                text: 'آیا کارت جاری را می‌خواهید فعال نمایید؟',
                buttons: [
                    {
                        title: 'بلی',
                        handler: () => { 
                            this.ActivateCard(this.id, this.price); 
                            this.$modal.hide('dialog');
                        }
                    },
                    {
                        title: 'خیر',
                        default: true,
                    }
                ]
            });
        },
        ActivateCard(id, price) {
            if (!Cookies.get('access_cookie')) {
                this.$router.push({ name: 'Login' });
            } else {
                postRequest('/cards/activate-card', { 
                    id: id,
                    price: price
                })
                    .then(() => {
                        // response
                        this.back()
                    })
                    .catch(err => {
                        // check auth
                        if (err.response) {
                            if (err.response.status == 401) {
                                Cookies.remove('access_cookie');
                                this.$router.push({ name: 'Login' });
                            }
                        }
                    });
            }
        },
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.mywealth-container {
    min-height: 100vh;
    width: 100%;
    padding: 0 0 1pt;

    position: relative;
}

/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.mywealth-container .header {
    min-height: 40vh;
    width: 100%;

    color: #000;
    background-color: #24327c;
    filter: blur(2px);

    position: relative;
    display: flex;
    flex-direction: column;
}
.mywealth-container .header p {
    margin: auto auto 0;
}
.mywealth-container .header h2 {
    margin: 1rem auto auto;
}
.mywealth-container .header .back-container {
    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}
.mywealth-container .header .back-container .title {
    margin-right: 10pt;
    font-weight: 500;
}
.mywealth-container .header .back-container .back {
    margin-top: 1pt;
}
.mywealth-container .header .back-container .title,
.mywealth-container .header .back-container .back {
    height: 20pt;
}

/* ---------------------------------------- */
/* ----------------- BTNS ----------------- */
/* ---------------------------------------- */
.mywealth-container .other-container {
    min-height: calc(60vh + 30pt);
    margin-top: -30pt;

    border-radius: 30pt;
    background-color: #f1f2f6;

    display: flex;
    flex-direction: column;
    position: relative;
}
.mywealth-container .other-container .btn-container {
    width: 100%;
    max-width: 300pt;
    margin: auto;

    display: flex;
}
.mywealth-container .other-container .btn-right,
.mywealth-container .other-container .btn-left {
    min-width: 100pt;
    padding: 1rem 0;
    margin: 0 auto;

    font-size: 80%;
    font-weight: bold;
    border-radius: 10pt;

    border: 1px solid;
}
.mywealth-container .other-container .btn-left {
    color: #f3481a;
    border-color: #f3481a;
    box-shadow: 3px 3px 6px 0px #f3481a5f;
}
.mywealth-container .other-container .btn-right {
    color: #2ad85f;
    border-color: #2ad85f;
    box-shadow: 3px 3px 6px 0px #2ad85f5f;
}

/* ---------------------------------------- */
/* ---------------- BANNER ---------------- */
/* ---------------------------------------- */
.mywealth-container .other-container .banner {
    width: calc(100% - 30pt);
    max-width: 300pt;
    margin: auto;
}
.mywealth-container .other-container .separator-line {
    height: 6pt;
    width: calc(100% - 50pt);
    margin: 0 auto;

    border-radius: 3pt;
    border: 1px solid #ddd;
    box-shadow: inset 3px 4px 4px -2px #ddd;
}
</style>
